import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Modal } from "@mui/material";
import React from "react";

const PDFViewModel = ({
  setPDFOpenModalShows,
  pdfOpenModalShows,
  setPDFView,
  pdfView,
}) => {
  return (
    <div>
      {" "}
      <Modal
        open={pdfOpenModalShows}
        onClose={() => {
          setPDFOpenModalShows(false);
        }}
        className="image-view-modal"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            // p: 4,
            py: 2,
            px: 1,

            height: "80%",
            outline: "none",
          }}
          className="shop-images-modal"
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton
              onClick={() => {
                setPDFOpenModalShows(false);
                setPDFView("");
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          {/* <img
            src={pdfView}
            alt="Full Size Image"
            className="view-shop-image"
          /> */}
          <iframe
            src={pdfView}
            width="100%"
            height="95%"
            style={{ border: "none" }}
          />
          {/* <Button
        onClick={() => {
          setPDFOpenModalShows(false);
          setPDFView("");
        }}
      >
        Close
      </Button> */}
        </Box>
      </Modal>
    </div>
  );
};

export default PDFViewModel;
